import {
  HirerPromoCodesBanner,
  type TrackingEvent,
} from '@seek/hirer-promo-codes-banner';
import { useCallback } from 'react';

import { trackPageInteraction } from 'src/modules/AnalyticsTracker';

export const PromoCodesBanner = () => {
  const trackPromoCode = useCallback((event: TrackingEvent) => {
    const eventName = event.eventName;
    trackPageInteraction(eventName, undefined, event);
  }, []);

  return (
    <HirerPromoCodesBanner
      onTrackingCallback={trackPromoCode}
      padding={{
        paddingX: { mobile: 'xsmall', tablet: 'gutter' },
        paddingY: 'medium',
      }}
    />
  );
};
